import { Tabs, TabPanel } from "react-tabs";
import ExploreProjectsStyleWrapper from "gamfi/sections/Projects/v4/ExploreProjects.style";
import ProjectCard from "./ProjectCard";

import { metaverse } from "data/metaverse";
import { formatEther, formatter, percent } from "utils/math";

import discord from "gamfi/assets/images/icons/discord.svg";
import medium from "gamfi/assets/images/icons/medium.svg";
import telegram from "gamfi/assets/images/icons/telegram.svg";
import twitter from "gamfi/assets/images/icons/twitter.svg";

import antimatterIcon from "assets/tokens/icon-antimatter-70.png";
import matterIcon from "assets/tokens/icon-matter-70.png";
import energyIcon from "assets/tokens/icon-energy-70.png";

import coinIcon from "gamfi/assets/images/project/project-single-image.png";
import { useCallback, useContext } from "react";
import { MetaverseContext } from "blockchain/provider";
import { useFetch } from "utils/hooks";
import { SectionTitle, SectionTitleWrapper } from "gamfi/components/sectionTitle";

const ExploreProjects = () => {
  const { energy, matter, antimatter } = useContext(MetaverseContext);
  const energySupply = Math.min(metaverse.matterSupply, metaverse.antimatterSupply) * 2;
  const fetchData = useCallback(async () => {
    const data = await Promise.all([energy.totalSupply(), matter.totalSupply(), antimatter.totalSupply()]);

    return {
      energyTS: formatEther(data[0]),
      matterTS: formatEther(data[1]),
      antimatterTS: formatEther(data[2]),
    };
  }, [energy, matter, antimatter]);

  const { data, loading, error } = useFetch(fetchData);
  if (error) {
    console.log({ error });
  }

  if (!data || loading) {
    return <></>;
  }

  return (
    <ExploreProjectsStyleWrapper>
      <div className="container">
        <SectionTitleWrapper>
          <SectionTitle title="METAVERSE TOKENS" subtitle="EXPLORE" isCenter={false} />
        </SectionTitleWrapper>
        <div className="row align-items-center single-project-row">
          <Tabs>
            {/* <TabList>
              {projects().map((child, i) => (
                <Tab key={i}>
                  <Button variant="outline" sm href={`#`} onClick={(e: any) => e.preventDefault()}>
                    {child.projectStatus}
                  </Button>
                </Tab>
              ))}
            </TabList> */}

            <TabPanel className="row tabs-row">
              <div className="col-lg-4 col-md-6">
                <ProjectCard
                  address={metaverse.energy}
                  coinIcon={coinIcon}
                  icon={energyIcon}
                  name="Energy Token"
                  symbol="BEG"
                  onAddToken={() => energy.addToken("BEG", "https://metaverse-energy.github.io/icon-energy.jpg")}
                  projectDetails={[
                    {
                      title: "Max Total Supply:",
                      text: formatter("BEG").format(energySupply),
                    },
                    {
                      title: "Total Supply:",
                      text: formatter("BEG").format(data.energyTS),
                    },
                    {
                      title: "Percent:",
                      text: percent(energySupply, data.energyTS).toFixed(2) + "%",
                    },
                  ]}
                  socialLinks={[
                    {
                      icon: telegram,
                      url: "#",
                    },
                    {
                      icon: discord,
                      url: "#",
                    },

                    {
                      icon: medium,
                      url: "#",
                    },
                    {
                      icon: twitter,
                      url: "#",
                    },
                  ]}
                />
              </div>
              <div className="col-lg-4 col-md-6">
                <ProjectCard
                  address={metaverse.matter}
                  coinIcon={coinIcon}
                  icon={matterIcon}
                  name="Matter Token"
                  symbol={"BMA"}
                  onAddToken={() => matter.addToken("BMA", "https://metaverse-energy.github.io/icon-matter.jpg")}
                  projectDetails={[
                    {
                      title: "Max Total Supply:",
                      text: formatter("BMA").format(metaverse.matterSupply),
                    },
                    {
                      title: "Total Supply:",
                      text: formatter("BMA").format(data.matterTS),
                    },
                    {
                      title: "Percent:",
                      text: percent(metaverse.matterSupply, data.matterTS).toFixed(2) + "%",
                    },
                  ]}
                  socialLinks={[
                    {
                      icon: telegram,
                      url: "#",
                    },
                    {
                      icon: discord,
                      url: "#",
                    },

                    {
                      icon: medium,
                      url: "#",
                    },
                    {
                      icon: twitter,
                      url: "#",
                    },
                  ]}
                />
              </div>
              <div className="col-lg-4 col-md-6">
                <ProjectCard
                  address={metaverse.antimatter}
                  coinIcon={coinIcon}
                  icon={antimatterIcon}
                  name="Antimatter Token"
                  symbol="BAM"
                  onAddToken={() =>
                    antimatter.addToken("BAM", "https://metaverse-energy.github.io/icon-antimatter.jpg")
                  }
                  projectDetails={[
                    {
                      title: "Max Total Supply:",
                      text: formatter("BAM").format(metaverse.antimatterSupply),
                    },
                    {
                      title: "Total Supply:",
                      text: formatter("BAM").format(data.antimatterTS),
                    },
                    {
                      title: "Percent:",
                      text: percent(metaverse.antimatterSupply, data.antimatterTS).toFixed(2) + "%",
                    },
                  ]}
                  socialLinks={[
                    {
                      icon: telegram,
                      url: "#",
                    },
                    {
                      icon: discord,
                      url: "#",
                    },

                    {
                      icon: medium,
                      url: "#",
                    },
                    {
                      icon: twitter,
                      url: "#",
                    },
                  ]}
                />
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </ExploreProjectsStyleWrapper>
  );
};

export default ExploreProjects;
